/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// Checkbox multiselect.
// This is a all or nothing checkbox_multiselect library. Considering using generic_checkbox_multiselect (GenericCheckboxMultiSelect) instead to achieve the same goal. 
// This code relies mainly on all checkboxes on the form needing to be maganged.
// GenericCheckboxMultiSelect's code relies on data attributes and meta items being set to precisely select the checkboxes that need managing.

// Requirements 
//# parent checkbox to have id oof "checkAll"
//# data attributes 
//### is-child, either true or false
//### parent-id, the checkbox id

namespace('Slzr.Page.CheckboxMultiSelect', (exports, top) => Slzr.jQuery(function($) {
  if (!$(document.body).is('.admin-filters-context') && !$(document.body).is(' .admin-moderation-index')) { return; }
  
  // Check or uncheck all checkboxes
  $('#checkAll').on('change', function(event) {
    return $(this).closest('form').find(':checkbox').prop('checked', this.checked);
  });

  // Decide how to display select all checkbox based on other checkboxes being checked or not
  //
  $("form input[type='checkbox']").on('change', function(event) {
    // Returns an array of 1 JQuery checkbox object
    const $checkAll = $('#checkAll');

    // Removes that one object from total number of checkbox JQuery objects found on the page
    const $checkboxes = $(this).closest('form').find(':checkbox').filter((index, $elm) => $elm !== $checkAll[0]);

    // Decides what to do with that one JQuery checkbox object based on the number of checkboxex checked
    return $checkAll.prop('checked', $checkboxes.filter(':checked').length === $checkboxes.length);
  });

  // Check all children under a parent filter. 
  // A parent can't be converted unless all of the children are converted with it or it doesno't have children
  //
  // When checkbox with data attribute is_child=false
  $("form :checkbox[data-is-child='false']").on('change', function(event) {
    const checkbox_id = $(this).val();
    return $(`form :checkbox[data-parent-id='${checkbox_id}']`).prop('checked', this.checked);
  });

  // Uncheck the parent checkbox if a child is de-selected
  return $("form :checkbox[data-is-child='true']").on('change', function(event) {
    // find the parent id of the child that has been clicked
    const parent_id = $(this).data('parentId');
    // get all checkboxes with that parent id
    const $checkboxes = $(`form :checkbox[data-parent-id='${parent_id}']`);
    
    // when a check event happens and all of the checkboxes are checked, check the checkbox with the value of the parent id of the child selected
    return $(`form :checkbox[value='${parent_id}']`).prop('checked', $checkboxes.filter(':checked').length === $checkboxes.length);
  });
}));
